import { FuseUtils } from '@fuse';

function AnotacaoListItemModel(data) {
    const item = data ? data : {};
    return {
        id: item.id || FuseUtils.generateGUID(),
        checked: item.checked || false,
        text: item.text || ''
    }
}

export default AnotacaoListItemModel;
